/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {ClaimsApi} from '../../../api/ms-claims/claims.api';
import {LoadingService} from '../../../shared/loading/loading-service/loading.service';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {ClaimDetailModel} from '../../../api/ms-claims/contracts/claim-detail.model';
import {ClaimBaseModel} from '../../../api/ms-claims/contracts/claim-base.model';

@Injectable({
    providedIn: 'root'
})
export class ClaimAttachmentsResolver  {

    constructor(private claimApi: ClaimsApi, private loadingService: LoadingService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<ClaimBaseModel> {
        this.loadingService.start();
        const claimNumber = route.params['claimNumber'];
        return this.claimApi.getClaimBaseInfo(claimNumber).pipe(
            finalize(() => this.loadingService.stop())
        );
    }
}
